import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class ShareRejected extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Share Rejected');
    public static getDescription:Function = () => Locale.gettext('A user rejected your share request');
    public static supportedRoutes:string[] = [ "push", "email" ];
}